<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <report-code-create-or-update v-model="reportCode" :errors="errors"></report-code-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ReportCodeCreateOrUpdate from './components/ReportCodeCreateOrUpdate.vue'
import NetsisOperationsApi from '@/api/netsis-operations';
export default {
    components:{
        BCard,
        ReportCodeCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Rapor Kodu",key:"Code", thClass:"w-100",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            reportCode:{
                Id:null,
                Code:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.reportCode.Id = null
            this.reportCode.Code = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return NetsisOperationsApi.ReportCode.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.reportCode.Id = item.Id
            this.reportCode.Code = item.Code
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            NetsisOperationsApi.ReportCode.CreateOrUpdate(this.editing,this.reportCode).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Code} rapor kodunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    NetsisOperationsApi.ReportCode.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>